const calculateHeaderHeight = () => {
  const header = document.querySelector("header");
  return header ? header.offsetHeight : 0;
};

const isDesktop = () => window.innerWidth >= 990;

const setTocTop = () => {
  const nav = document.querySelector(".content-navigation");
  if (!nav) return;

  const offset = isDesktop() ? 170 : 0;
  nav.style.top = `${offset}px`;
  document.documentElement.style.setProperty("--header-height", `${calculateHeaderHeight()}px`);
};

window.addEventListener("resize", setTocTop);
setTocTop();
